import {
  ALL_APP_ROUTES,
  APP_CONTEXT_ROUTES,
  GROUP_CONTEXT_ROUTES,
  SELECTION_SYNC_EXCLUDED_ROUTES,
} from '../constants/routing';
import { isAllSelection } from '../utils/selection';
import {
  buildApplicationDashboardPath,
  buildApplicationGroupDashboardPath,
  isScopedAdminPath,
} from './pathUtils';
import pages from './routes';

export const getHomeDashboardRedirectPath = ({
  isUrlNavigationEnabled,
  pathname,
  selectedGroupId,
  selectedApplicationId,
  neutralDashboardPath,
}: {
  isUrlNavigationEnabled: boolean;
  pathname: string;
  selectedGroupId?: string;
  selectedApplicationId?: string;
  neutralDashboardPath: string;
}) => {
  if (
    !isUrlNavigationEnabled ||
    (pathname !== pages.home.path && pathname !== pages.dashboard.path)
  ) {
    return undefined;
  }

  if (!selectedGroupId || isAllSelection(selectedGroupId)) {
    return neutralDashboardPath;
  }

  if (selectedApplicationId && !isAllSelection(selectedApplicationId)) {
    return buildApplicationDashboardPath(
      selectedGroupId,
      selectedApplicationId
    );
  }

  return buildApplicationGroupDashboardPath(selectedGroupId);
};

const isLegacyDetailPath = (pathname: string) => {
  const [, rootPath, childPath] = pathname.split('/');

  return (
    childPath !== undefined &&
    childPath !== '' &&
    childPath !== 'create' &&
    (APP_CONTEXT_ROUTES.includes(rootPath) ||
      GROUP_CONTEXT_ROUTES.includes(rootPath))
  );
};

export const getSelectionSyncRedirectPath = ({
  isUrlNavigationEnabled,
  pathname,
  selectedGroupId,
  selectedApplicationId,
  neutralDashboardPath,
  initialPathname,
  hasSkippedInitialLegacyDetailSync = true,
}: {
  isUrlNavigationEnabled: boolean;
  pathname: string;
  selectedGroupId?: string;
  selectedApplicationId?: string;
  neutralDashboardPath: string;
  initialPathname?: string;
  hasSkippedInitialLegacyDetailSync?: boolean;
}) => {
  if (isScopedAdminPath(pathname)) {
    return undefined;
  }

  if (
    !hasSkippedInitialLegacyDetailSync &&
    initialPathname !== undefined &&
    pathname === initialPathname &&
    isLegacyDetailPath(pathname)
  ) {
    return undefined;
  }

  const rootPath = pathname.split('/')[1];

  if (rootPath === '') {
    return neutralDashboardPath;
  }

  if (SELECTION_SYNC_EXCLUDED_ROUTES.includes(rootPath)) {
    return undefined;
  }

  if (ALL_APP_ROUTES.includes(rootPath)) {
    return undefined;
  }

  if (
    isUrlNavigationEnabled &&
    (APP_CONTEXT_ROUTES.includes(rootPath) ||
      GROUP_CONTEXT_ROUTES.includes(rootPath))
  ) {
    return undefined;
  }

  if (
    isUrlNavigationEnabled &&
    selectedGroupId &&
    !isAllSelection(selectedGroupId) &&
    !ALL_APP_ROUTES.includes(rootPath)
  ) {
    if (selectedApplicationId && !isAllSelection(selectedApplicationId)) {
      return buildApplicationDashboardPath(
        selectedGroupId,
        selectedApplicationId
      );
    }

    return buildApplicationGroupDashboardPath(selectedGroupId);
  }

  if (
    isAllSelection(selectedApplicationId) &&
    !ALL_APP_ROUTES.includes(rootPath)
  ) {
    return neutralDashboardPath;
  }

  if (selectedApplicationId !== undefined) {
    return `/${rootPath}`;
  }

  return undefined;
};
